import React from 'react';

import styled from '@emotion/styled';

const StakingPersonasEmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-inline: auto;
  padding-inline: ${({ theme }) => theme.spacing('0500')};
  padding-block: ${({ theme }) => theme.spacing('3000')};
  gap: ${({ theme }) => theme.spacing('1500')};
  max-width: 320px;

  svg {
    width: ${({ theme }) => theme.size['2500']};
    height: ${({ theme }) => theme.size['2500']};
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: ${({ theme }) => theme.spacing('3000')};
  }
`;

const Title = styled.span`
  color: ${({ theme }) => theme.color.onBackground};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['3']};

  text-align: center;
`;

const Subtitle = styled.span`
  color: ${({ theme }) => theme.color.onBackground};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['1']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
  text-align: center;
`;

const Action = styled.div``;

export interface IStakingPersonasEmptyProps {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  action: React.ReactNode | null;
}

export const StakingPersonasEmpty = ({
  icon,
  subtitle,
  title,
  action,
}: IStakingPersonasEmptyProps) => (
  <StakingPersonasEmptyContent>
    {icon}
    <Title>{title}</Title>
    <Subtitle>{subtitle}</Subtitle>
    <Action>{action}</Action>
  </StakingPersonasEmptyContent>
);
